module.exports = __webpack_public_path__ + "static/media/todd-architects.a0b404b1.png";